import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  currentTab: string;
  constructor(private router: Router) { 
  	this.currentTab = this.router.url;
  }

  ngOnInit() {
  }

}
